import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { APDocument, DocumentFilters } from "../../types/Document";
import { PaginationResponse } from "../../types/Pagination";

export const getEmployerDocuments = (
  filters: DocumentFilters,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, pageSize, accountIds, documentTypes, ...otherFilters } =
    filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["getEmployerDocuments", filters],
    queryFn: (): Promise<PaginationResponse<APDocument>> => {
      return fetchWithAuth<PaginationResponse<APDocument>>(
        "getEmployerDocuments",
        undefined,
        {
          queryParams: {
            ...otherFilters,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
            accountIds: accountIds ? accountIds.join(",") : undefined,
            documentTypes: documentTypes ? documentTypes.join(",") : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
  });
};
